import React from "react";
import { AlertCircle, Info } from "lucide-react";
import Modal from "./Modal";

const ErrorModal = ({
  open,
  title = "Something went wrong",
  subtitle,
  message,
  children,
  actions = [],
  onClose,
  footerNote,
  maxWidth = "max-w-lg",
}) => (
  <Modal open={open} onClose={onClose} className={`relative overflow-hidden ${maxWidth}`}>
    <div className="bg-error p-5 sm:p-6">
      <div className="flex items-center">
        <div className="bg-surface-lowest/20 p-3 rounded-full mr-4">
          <AlertCircle className="w-8 h-8 text-surface-lowest" strokeWidth={2} />
        </div>
        <div>
          <h3 className="text-xl font-bold text-surface-lowest">{title}</h3>
          {subtitle && <p className="text-error-container text-sm mt-1">{subtitle}</p>}
        </div>
      </div>
    </div>

    <div className="p-5 sm:p-6">
      {message && <p className="text-on-primary-fixed-var font-medium mb-3">{message}</p>}
      {children}

      {actions.length > 0 && (
        <div className={`grid gap-3 mt-6 ${actions.length > 2 ? "grid-cols-1 sm:grid-cols-3" : "grid-cols-1 sm:grid-cols-2"}`}>
          {actions.map(({ label, onClick, icon: Icon, primary }) => (
            <button
              key={label}
              onClick={onClick}
              className={`px-4 py-3 font-semibold rounded-xl transition-colors flex items-center justify-center text-sm ${
                primary
                  ? "bg-primary text-surface-lowest hover:bg-primary-container"
                  : "bg-surface-container text-on-primary-fixed-var hover:bg-surface-variant"
              }`}
            >
              {Icon && <Icon className="w-4 h-4 mr-2" />}
              {label}
            </button>
          ))}
        </div>
      )}

      {footerNote && (
        <div className="mt-5 pt-4 border-t border-surface-container">
          <div className="flex items-center text-on-surface-variant text-sm">
            <Info className="w-4 h-4 mr-2 flex-shrink-0" />
            <p>{footerNote}</p>
          </div>
        </div>
      )}

      {onClose && actions.length === 0 && (
        <button
          onClick={onClose}
          className="w-full mt-4 px-4 py-2.5 bg-surface-low text-on-primary-fixed-var font-medium rounded-lg border border-surface-container hover:bg-surface-container transition-colors text-sm"
        >
          Close
        </button>
      )}
    </div>
  </Modal>
);

export default ErrorModal;
